import { useIntl } from "react-intl";
import { Dialog } from "../../../../common/core-ui/Dialog.tsx";
import { useLayoutData } from "../layout/myCoursesLayoutLoader.ts";
import { CourseMaterial } from "./coursesLoader.ts";

export default function LmsLinkDialog({
  href,
  onRequestClose,
  materialFormat,
}: {
  href: string;
  onRequestClose: () => void;
  materialFormat?: CourseMaterial["materialFormat"];
}) {
  const intl = useIntl();
  const { config } = useLayoutData();
  const label = intl.formatMessage(
    { defaultMessage: "Go to {lmsLabel}" },
    { lmsLabel: config.lms.label }
  );
  const text = intl.formatMessage(
    {
      defaultMessage: `Currently, this material is only accessible through {lmsLabel}. Please open this dashboard in {lmsLabel} and click "{lmsAction}" there.`,
    },
    {
      lmsLabel: config.lms.label,
      lmsAction: materialFormat === "bundle" ? "Access Instructions" : "Open",
    }
  );
  const title = intl.formatMessage(
    { defaultMessage: "Access through {lmsLabel}" },
    { lmsLabel: config.lms.label }
  );

  return (
    <Dialog
      title={title}
      onRequestClose={onRequestClose}
      primaryButton={{ href, label }}
    >
      {text}
    </Dialog>
  );
}
